module.exports = __webpack_public_path__ + "static/media/4.485a276f.jpg";